// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/img1.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  min-height: 100vh;
}

.content-box {
  background-color: rgba(255, 255, 255, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  padding: 40px !important;
  border-radius: 20px;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.3) !important;
  margin-top: 30px;
  margin-bottom: 50px;
}

.content-box h1, 
.content-box h2, 
.content-box p, 
.content-box table, 
.content-box label,
.content-box td,
.content-box th {
  color: #333 !important; 
  text-shadow: none;
}

.content-box a {
  color: #0056b3 !important;
  text-decoration: none;
  font-weight: bold;
}

.content-box a:hover {
  text-decoration: underline;
}

.content-box a.text-danger {
  color: #dc3545 !important; 
}

.navbar {
  margin-bottom: 0 !important;
}

`, "",{"version":3,"sources":["webpack://./frontend/assets/css/style.css"],"names":[],"mappings":"AAAA;EACE,oEAAmD;EACnD,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,sDAAsD;EACtD,sCAAsC;EACtC,8CAA8C;EAC9C,wBAAwB;EACxB,mBAAmB;EACnB,uDAAuD;EACvD,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":["body {\n  background-image: url('../img/img1.jpg') !important;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  background-attachment: fixed;\n  min-height: 100vh;\n}\n\n.content-box {\n  background-color: rgba(255, 255, 255, 0.15) !important;\n  backdrop-filter: blur(10px) !important;\n  -webkit-backdrop-filter: blur(10px) !important;\n  padding: 40px !important;\n  border-radius: 20px;\n  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.3) !important;\n  margin-top: 30px;\n  margin-bottom: 50px;\n}\n\n.content-box h1, \n.content-box h2, \n.content-box p, \n.content-box table, \n.content-box label,\n.content-box td,\n.content-box th {\n  color: #333 !important; \n  text-shadow: none;\n}\n\n.content-box a {\n  color: #0056b3 !important;\n  text-decoration: none;\n  font-weight: bold;\n}\n\n.content-box a:hover {\n  text-decoration: underline;\n}\n\n.content-box a.text-danger {\n  color: #dc3545 !important; \n}\n\n.navbar {\n  margin-bottom: 0 !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
